import systemActions from "../actions/system";

const storedLanguage = localStorage.getItem("language");
const initialState = {
  currentLangCode: storedLanguage,
  units: [],
  toolbarTitle: "",
  storages: [],
  showChangeOrganizationModal: false,
  paymentTypes: [],
  currencies: [],
  defaultStorage: null,
  translations: {},
  langCodes: [],
  hasStock: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case systemActions.ToggleOrganizationModal.TRIGGER: {
      return { ...state, showChangeOrganizationModal: action.payload };
    }
    case systemActions.SetToolbarTitle.TRIGGER: {
      return { ...state, toolbarTitle: action.payload };
    }
    case systemActions.ChangeLanguage.TRIGGER: {
      return { ...state, currentLangCode: action.payload };
    }
    case systemActions.GetUnits.SUCCESS: {
      return { ...state, units: action.payload };
    }
    case systemActions.GetCurrencyRates.SUCCESS: {
      return { ...state, currencies: action.payload };
    }
    case systemActions.GetStorages.SUCCESS: {
      const isDefault = action.payload.find((s) => s.is_default === 1);
      return {
        ...state,
        storages: action.payload,
        defaultStorage: isDefault ? isDefault : action.payload[0],
      };
    }
    case systemActions.SetDefaultStorage.TRIGGER: {
      return {
        ...state,
        defaultStorage: action.payload,
      };
    }
    case systemActions.GetPaymentTypes.SUCCESS: {
      return { ...state, paymentTypes: action.payload };
    }
    case systemActions.UpdateCurrency.SUCCESS: {
      return { ...state, currencies: [action.payload] };
    }
    case systemActions.SetTranslations.TRIGGER: {
      return { ...state, translations: action.payload };
    }
    case systemActions.SetLangCodes.TRIGGER: {
      return { ...state, langCodes: action.payload };
    }
    case systemActions.SetHasStock.TRIGGER: {
      return { ...state, hasStock: action.payload };
    }
    case systemActions.SetHasTax.TRIGGER: {
      return { ...state, hasTax: action.payload };
    }
    default:
      return state;
  }
};
